//@ts-check
import dataGridAction from './grid';
import dataListAction from './list';
import dataItemAction from './item';
/**
 * Functions that work well with the other data components
 * `DataItem`, `DataGrid`
 * @type {import('./types').DataAction}
 */

var DataAction = {
  item: function item(itemIdentifier) {
    return dataItemAction(itemIdentifier);
  },
  list: function list(where) {
    return dataListAction(where);
  },
  grid: function grid(where) {
    return dataGridAction(where);
  }
};
export default DataAction;